// @flow

import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { ButtonWrapper } from 'client/components/preRegistration/preRegistration';
import { PRE_REG_COMPLETE_CTA } from 'client/constants/amplitudeTracker';

import { Tracking } from 'web-core/src/tracking';

type Props = {
  ctaBtn: string,
  ctaPath: string,
  header: string,
  subheader: string,
};

const CheckMark = styled.div`
  height: ${rem(62)};
  width: ${rem(62)};
  margin: 0 auto 1rem;
`;

const Complete = (props: Props) => {
  const { ctaPath, ctaBtn, header, subheader } = props;
  const handleRedirect = () => {
    Tracking.track(PRE_REG_COMPLETE_CTA, { path: ctaPath });
    window.location.href = ctaPath;
  };

  return (
    <React.Fragment>
      <CheckMark>
        <img
          alt="check mark"
          src="https://images.ctfassets.net/heg7gyzix6dq/1XiUBzqKAA08wDzZjLTOx/5c8b3e2f1d26665ad66d351fc88dbb46/checkmark.svg" />
      </CheckMark>
      <h1 className="medium">{header}</h1>
      <h3>{subheader}</h3>
      <ButtonWrapper clickHandler={handleRedirect}>{ctaBtn}</ButtonWrapper>
    </React.Fragment>
  );
};

export default Complete;
